import React, { useState } from 'react';
import ImageWithFallback from './ImageWithFallback';

const ImageGallery = ({ images, onImageClick }) => {
  const [validImages, setValidImages] = useState(new Set(images.map((_, i) => i)));

  const handleImageError = (index) => {
    setValidImages(prev => {
      const newSet = new Set(prev);
      newSet.delete(index);
      return newSet;
    });
  };
  return (
    <div className="max-w-7xl mx-auto px-4 py-16">
      <h2 className="text-4xl md:text-5xl font-bold text-center mb-12 text-gray-800">
        Gallery
      </h2>
      
      {/* Masonry Grid Layout */}
      <div className="columns-1 md:columns-2 lg:columns-3 gap-4 space-y-4">
        {images.map((image, index) => {
          if (!validImages.has(index)) return null;
          
          return (
            <div
              key={index}
              className="break-inside-avoid group relative cursor-pointer overflow-hidden rounded-lg shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-[1.02]"
              onClick={() => onImageClick(index)}
            >
              <ImageWithFallback
                src={image.url}
                alt={image.alt}
                className="w-full h-auto object-cover transition-transform duration-500 group-hover:scale-110"
                onError={() => handleImageError(index)}
              />
            
            {/* Overlay on Hover */}
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-all duration-300 flex items-center justify-center">
              <svg 
                className="w-12 h-12 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v6m3-3H7" 
                />
              </svg>
            </div>

            {/* Optional Caption */}
            {image.caption && (
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <p className="text-white text-sm font-medium">{image.caption}</p>
              </div>
            )}
          </div>
          );
        })}
      </div>
    </div>
  );
};

export default ImageGallery;

